module.exports = __webpack_public_path__ + "img/pc_banner_bottom.34384a8.webp";